// @flow

import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const FramedText = styled.div`
  border: 3px solid #fff;
  padding: 0.3em 0.5em;
  font-size: 0.8em;

  text-transform: uppercase;
  font-weight: bold;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const Text = styled.div`
  font-size: 0.95em;
  white-space: nowrap;
`;

export const JuegoConResponsabilidad = (): React$Element<*> => (
  <FramedText>{'Juego Con Responsabilidad'}</FramedText>
);

export const NoHayJuego = (): React$Element<*> => <Text>{'Sin diversión no hay juego'}</Text>;

export const SejaResponsavel = (): React$Element<*> => (
  <Text>{'Seja responsável, jogue com moderação'}</Text>
);
